<template>
  <v-dialog
    v-model="showModal"
    persistent
    :max-width="logs ? '1000px' : '500px'"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ getTitle }}</h3>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row>
          <v-col cols="12" md="12">
            <el-simple-table :items="logDataList" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Atgal"
          :loading="loading"
          @click.native.stop="closeModal()"
          color="secondary"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalBrokerLogs',
  props: {
    logs: Boolean,
    logTitle: String,
    item: Object,
    value: Boolean,
    loading: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {}
  },
  computed: {
    getTitle() {
      if (this.logs) {
        return `${this.logTitle} ${this.item?.id || ''}`
      }
      return `Broker užklausa ${this.item?.id || ''}`
    },
    logDataList() {
      if (this.logs) {
        return [
          {
            title: 'Užklausa',
            value: this.item?.request_data || '',
            trStyle: 'white-space: break-spaces;',
            canCopy: true,
          },
          {
            title: 'Atsakymas',
            value: this.item?.response || '',
            canCopy: true,
          },
          {
            title: 'Adresas / metodas',
            value: this.item?.address || '',
          },
          {
            title: 'Užklausos laikas',
            value: this.item?.created_at || '',
          },
        ]
      } else {
        return [
          {
            title: 'Užklausa',
            value: this.item?.request || '',
            trStyle: 'white-space: break-spaces;',
            canCopy: true,
          },
          {
            title: 'Atsakymas',
            value: this.item?.response || '',
            canCopy: true,
          },
          {
            title: 'Paslauga',
            value: this.item?.action || '',
          },
          {
            title: 'Užklausos laikas',
            value: this.item?.created_at || '',
          },
        ]
      }
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },

    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped></style>
